<template>
    <div class="badgebox-success-no-sample">
        <Badgebox :key="data.key">
            <p
                v-bastards
                class="fs-18 fs-lh-24 text-center"
                style="padding-bottom: 16px;"
            >
                Przykro nam, ale pula wybranej przez Ciebie próbki właśnie się wyczerpała. W zamian proponujemy <strong>kupon rabatowy o wartości 10%</strong> na ten produkt.
            </p>
            <p
                v-bastards
                class="fs-16 text-bold text-center"
            >
                Kupon wysłaliśmy na Twój adres e-mail.
            </p>

            <p class="badgebox-footer fs-13 text-center text-paragraph">
                Posługujesz się nowym adresem e-mail? 
                <a 
                    class="link-underline-in"
                    @click.prevent="$router.push({ name: 'index' })"
                >
                    Zaktualizuj swoje dane &raquo;
                </a>
            </p>
        </Badgebox>
    </div>
</template>

<script>
import Badgebox from '@/components/badgebox/Badgebox'

export default {
    components: {
        Badgebox
    },

    props: {
        data: {
            type: Object,
            required: false,
            default: () => {}
        }
    }
}
</script>

<style>

</style>
